import { getJsonOrError } from './../../utils/fetch'
import { get as getFromPdo } from './../../application/pageDataObject'
import URLSearchParams from 'url-search-params'

export class PrivateMessagesProvider {
  send = (msg, to) =>
    getJsonOrError(this.getMessagesApi, {
      credentials: 'include',
      method: 'post',
      headers: {
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
      },
      body: this.convertToForm(msg, to),
    })

  convertToForm = (msg, to) => {
    const params = {
      'message[text]': msg,
      'message[to_user_id]': to,
    }

    const searchParams = new URLSearchParams()
    for (const prop in params) {
      searchParams.set(prop, params[prop])
    }

    return searchParams
  }

  getMessagesApi = getFromPdo('config.api.messages')
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/PrivateMessages/index.js